import { apiClient } from './apiClient';
import { authService } from './authService';

const getCompanyParam = () => {
  const companyId = authService.getCompanyId();
  return companyId ? `companyId=${companyId}` : '';
};

export const reportService = {
  /**
   * Get report summary with KPIs
   * @param {number} days - Number of days to include (default 30)
   */
  async getReportSummary(days = 30) {
    return apiClient.get(`/api/cmms/reports/summary?${getCompanyParam()}&days=${days}`);
  },

  /**
   * Get monthly report data
   * @param {number} months - Number of months to include (default 6)
   */
  async getMonthlyReport(months = 6) {
    return apiClient.get(`/api/cmms/reports/monthly?${getCompanyParam()}&months=${months}`);
  },

  /**
   * Get asset performance metrics
   * @param {number} days - Number of days to include (default 30)
   */
  async getAssetPerformance(days = 30) {
    return apiClient.get(`/api/cmms/reports/asset-performance?${getCompanyParam()}&days=${days}`);
  },
};

// Date range options for reports
export const DATE_RANGE_OPTIONS = [
  { value: '7', label: 'Last 7 days', days: 7 },
  { value: '30', label: 'Last 30 days', days: 30 },
  { value: '90', label: 'Last 90 days', days: 90 },
  { value: '365', label: 'This year', days: 365 },
];
